import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom';

// import 'react-datepicker/dist/react-datepicker.css';
// import '../../../../../node_modules/react-dropzone-component/styles/filepicker.css';
// import '../../../../../node_modules/dropzone/dist/min/dropzone.min.css';

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
// import FormsInputsText from '../../inputs/text/forms_inputs_text';
// import FormsInputDate from '../../inputs/date';
// import FormsInputDropdown from '../../inputs/dropdown';
// // import FormsInputsRadioGroup from '../../inputs/radio';
// import FormsInputsRadioGroupDynamic from '../../inputs/radiodynamic';
// // import FormsInputsDropdownAddition from '../../inputs/dropdownaddition';
// // import FormsInputsTime from '../../inputs/time';

import ListMSBillingCompanySelection from '../../client/list_ms_billing_company_selection';  
import {getSystemAdminCompanies} from '../../../../actions/index'


const filterOptions = [
    { key: 'companyName', text: 'Company Name', value: 'companyName' }, 
    { key: 'groupCode', text: 'Group Code', value: 'groupCode' },
    { key: 'policyNo', text: 'Policy No', value: 'policyNo' },
]

class SysadminFormsClientAdd extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false,
        openModalSelectCompany: true,
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        filter: 'companyName',
        query: '',
        clients:[],
        companyName:null,
        groupCode:null,
        policyNo:null,
        isLoading:false,
        isSearch:false
    }
    renderSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Client Created Successfully!</Message.Header>
                    <p>
                        <Link to="/systemadmin">
                            Click here to view the client now!
                        </Link>
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }

    // ------- func
    componentDidMount(){   
        if(this.props.user){
            this.getClients()
        }
    }
    getClients = () => { 
        this.setState({isLoading: true})
        const { accessToken } = this.props.user;  
        let params = {}

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query 
        } 
        getSystemAdminCompanies({
            accessToken,
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            params
        }, (result, error) => {  
            if(result && result.data) { 
                if(result.data.pagination) {
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                    })
                }
                if(result.data.companies) {  
                    this.setState({
                        clients: result.data.companies,
                        isLoading: false, 
                    })
                }
            }
        });
    }
    showCompanyDialog(isShow) {
        if (isShow) {
            this.setState({
                ...this.state,
                openModalSelectCompany: true,
            })
        } else {
            this.setState({
                ...this.state,
                openModalSelectCompany: false,
            })
        }
    }

    onSelectCompany(client,formikData){ 
        formikData.setFieldValue("name", client.companyName);
        formikData.setFieldValue("groupCode", client.groupCode);
        formikData.setFieldValue("policyNo", client.policyNo); 
        formikData.setFieldValue("companyMS_company_id",client._id)
        this.showCompanyDialog(false);
    }
    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => {
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        if (this.state.clients.length >= this.state.perPage) {
            this.setState({ currentPage: this.state.currentPage + 1 }, () => {
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num }, () => {
            this.getClients();
        });
    }

    setPerPage = (num) => { 
        this.setState({ perPage: num, currentPage: 1 }, () => {
            this.getClients();
        });
    }

    submitFilter = () => {
        if (this.state.query !== '') {
            this.setState({...this.state, currentPage: 1, isSearch:true}, () => {
                this.getClients();
            });
        }
    }

    clearFilter = () => {
        this.setState({ query: '',isSearch:false }, () => {
            this.getClients();
        });
    }

    checkClearFilter = (e) => {
        if(e.target.value == ""){
            this.setState({ query: '' }, () => {
            this.getClients();
        });
        }
        this.setState({ query: e.target.value })
    }
 
    onFilterDropdownChange = (e,{name, value}) => {    
        if(e.target.value == ""){
            this.setState({ filter: '' })
        } else {
            this.setState({ filter: value });
        }
    }
    // ------- funt
    render() {
        return (
            <Formik
                initialValues={{ 
                    name: '',
                    groupCode: '',
                    policyNo: '',
                    companyMS_company_id: ''
                    // inpatientPolicyNo: '',
                    // outpatientPolicyNo: '',
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    this.setState({error: false, errorMessage: null, success: false});
                    this.props.submitSystemAdminCreateClient(
                        {accessToken: this.props.user.accessToken, data: values},
                        (result, error) => {
                            if (result) {
                                actions.setSubmitting(false);
                                this.setState({error: false, errorMessage: null, success: true});
                                actions.resetForm({ 
                                    name: '',  
                                    groupCode: '',
                                    policyNo: '',  
                                    companyMS_company_id:''
                                })
                            }
                            if (error) {
                                actions.setSubmitting(false);
                                this.setState({error: true, errorMessage: error.errorMessage});
                            }
                        }
                    )
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                    <Form style={{padding: 20}}>
                        {this.props.user && <ListMSBillingCompanySelection
                            open={ this.state.openModalSelectCompany }
                            clients={this.state.clients} 
                            onSelectCompany={ (client) => {
                                            this.onSelectCompany(client, {setFieldValue});
                                        }}
                            onClose={()=>{ this.showCompanyDialog(false) }}
                            currentPage={this.state.currentPage }
                            perPage={this.state.perPage }
                            totalPage={this.state.totalPage }
                            totalData={this.state.totalData }
                            filter={this.state.filter }
                            query={ this.state.query } 
                            submitFilter={ this.submitFilter.bind(this) }
                            clearFilter={ this.clearFilter.bind(this) }
                            checkClearFilter={ this.checkClearFilter.bind(this) }

                            goToPreviousPage={ this.goToPreviousPage.bind(this) }
                            goToNextPage={ this.goToNextPage.bind(this) }
                            setPage={ this.setPage.bind(this) }
                            setPerPage={ this.setPerPage.bind(this) }

                            onFilterDropdownChange={this.onFilterDropdownChange.bind(this)}
                            filterOptions={filterOptions}
                            isLoading={this.state.isLoading}
                            isSearch={this.state.isSearch}
                        />}
                        <Grid container columns={2}>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Company Basic Information
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="name" 
                                    label="Company Name" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="groupCode" 
                                    label="Group Code" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="policyNo" 
                                    label="Policy Number" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled
                                />
                            </Grid.Column>
                            {/* <Grid.Column>
                                <Field 
                                    name="inpatientPolicyNo" 
                                    label="Inpatient Policy Number" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="outpatientPolicyNo" 
                                    label="Outpatient Policy Number" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                />
                            </Grid.Column> */}
                            <Grid.Column width={16}>
                                <Button 
                                    loading={isSubmitting}
                                    type="submit" 
                                    primary 
                                    disabled={isSubmitting}
                                    fluid
                                    size="big"
                                >
                                    Create New Client
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.renderSubmissionResult()}
                            </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}


const mapStateToProps = (state) => {   
    return {
        user: state.user.user, 
        companies: state.systemAdmin.companies
    }
}
   

export default connect(mapStateToProps, { 
    getSystemAdminCompanies
})(SysadminFormsClientAdd); 